<template>
        <slot name="default"></slot>
</template>

  
<script setup>

</script>
    